export const ADA_CHAT_BOT_HANDLE = 'mews';
